module.exports = __webpack_public_path__ + "img/suning.16f9cd3b.png";